import { SET_CLASSIFY_IMAGE, RESET_CLASSIFY_IMAGE, CLASSIFY_PLANT } from '../actions'

const INITIAL_STATE = {
    image: null,
    recognizedPlant: null,
    reliability: null,
}

function ClassifierReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_CLASSIFY_IMAGE:
            return {
                ...state,
                image: action.payload,
            }
        case RESET_CLASSIFY_IMAGE:
            return {
                ...state,
                image: null,
                recognizedPlant: null,
                recognizedPlantAccuracy: null,
            }
        case CLASSIFY_PLANT:
            return {
                ...state,
                recognizedPlant: action.payload.indexOf(Math.max(...action.payload)),
                reliability: Math.max(...action.payload),
            }
        default: return state
    }
}

export default ClassifierReducer



// WEBPACK FOOTER //
// ./src/reducers/classifier.js